import { ChangeDetectionStrategy, Component, model, input } from '@angular/core';

@Component({
  selector: 'lib-checkbox',
  imports: [],
  templateUrl: './checkbox.html',
  styleUrl: './checkbox.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[style.--checkbox-size]': 'size()',
    '[style.--checkbox-color]': 'color()',
    '[style.--checkbox-bg]': 'bg()',
    '[style.--checkbox-border]': 'border()',
  },
})
export class Checkbox {
  public readonly checked = model(false);
  public readonly label = input('');
  public readonly size = input('24px');
  public readonly color = input('#aaaaaa');
  public readonly bg = input('#999999');
  public readonly border = input('#888888');
}
